import React, { Component } from "react";
import styled from "styled-components";
import Header from "../Component/Header";
import Contents from "../Component/Contents";
import Buttons from "../Component/Buttons";
import Cont from "../Component/Container";
import MainPic from "../Img/OREO.png";

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="fadeIn">
        <Cont className="container">
          <Header
            title={MainPic}
            desc="오레오는 하버드의 150년 전통 글쓰기 연습법입니다."
            stage="0"
          ></Header>
          <Buttons array={[["시작하기", "/target"]]}></Buttons>
        </Cont>
      </div>
    );
  }
}

export default Main;
